var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__loading"},[_c('van-loading',{attrs:{"size":"30px","text-size":"24px","text-color":"#fff","vertical":""}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }